
// Este arquivo agora é a fonte única para tipos e configurações de perfis.

// Tipos que estavam em `types.ts` agora estão aqui para quebrar a dependência circular.
export type UserRole = 'administrador' | 'vendedor' | 'cliente';

export type Permission =
  | 'view_dashboard'
  | 'manage_orcamentos'
  | 'delete_orcamento'
  | 'view_ecommerce'
  | 'manage_cadastros_filamentos'
  | 'manage_cadastros_tipos_filamentos'
  | 'manage_cadastros_impressoras'
  | 'manage_cadastros_marcas'
  | 'manage_cadastros_nichos'
  | 'manage_cadastros_produtos'
  | 'view_estoque'
  | 'manage_configuracoes_sistema'
  | 'manage_permissoes_usuarios'
  | 'view_relatorios'
  | 'manage_tarefas'
  | 'calibracoes:read'
  | 'calibracoes:write'
  | 'calibracoes:delete'
  | 'calibracoes:manage_tipos';

export interface RoleConfig {
  name: string;
  description: string;
  permissions: Permission[];
}

export type RolesConfig = Record<UserRole, RoleConfig>;

// Constantes
export const USER_ROLES_AVAILABLE: UserRole[] = ['administrador', 'vendedor', 'cliente'];

export const ALL_PERMISSIONS: Permission[] = [
  'view_dashboard',
  'manage_orcamentos',
  'delete_orcamento',
  'view_ecommerce',
  'manage_cadastros_filamentos',
  'manage_cadastros_tipos_filamentos',
  'manage_cadastros_impressoras',
  'manage_cadastros_marcas',
  'manage_cadastros_nichos',
  'manage_cadastros_produtos',
  'view_estoque',
  'manage_configuracoes_sistema',
  'manage_permissoes_usuarios',
  'view_relatorios',
  'manage_tarefas',
  'calibracoes:read',
  'calibracoes:write',
  'calibracoes:delete',
  'calibracoes:manage_tipos',
];

export const PERMISSION_DESCRIPTIONS: Record<Permission, string> = {
  view_dashboard: "Visualizar Painel Principal",
  manage_orcamentos: "Gerenciar Orçamentos (Criar, Editar)",
  delete_orcamento: "Excluir Orçamentos",
  view_ecommerce: "Acessar Catálogo/E-commerce",
  manage_cadastros_filamentos: "Gerenciar Cadastro de Filamentos",
  manage_cadastros_tipos_filamentos: "Gerenciar Cadastro de Tipos de Filamentos",
  manage_cadastros_impressoras: "Gerenciar Cadastro de Impressoras",
  manage_cadastros_marcas: "Gerenciar Cadastro de Marcas",
  manage_cadastros_nichos: "Gerenciar Cadastro de Nichos de Produtos",
  manage_cadastros_produtos: "Gerenciar Cadastro de Produtos e Custos",
  view_estoque: "Visualizar e Gerenciar Estoque",
  manage_configuracoes_sistema: "Acessar e Modificar Configurações do Sistema",
  manage_permissoes_usuarios: "Gerenciar Perfis e Permissões de Usuários",
  view_relatorios: "Visualizar Relatórios do Sistema",
  manage_tarefas: "Usar o quadro de Tarefas (criar, mover, comentar)",
  'calibracoes:read': "Visualizar Sistema de Calibrações",
  'calibracoes:write': "Criar e Executar Calibrações",
  'calibracoes:delete': "Excluir Calibrações",
  'calibracoes:manage_tipos': "Gerenciar Tipos de Calibração",
};


export const ROLES_CONFIG: RolesConfig = {
  administrador: {
    name: 'Administrador',
    description: 'Acesso total a todas as funcionalidades do sistema.',
    permissions: ALL_PERMISSIONS,
  },
  vendedor: {
    name: 'Vendedor',
    description: 'Acesso para criar e gerenciar orçamentos, visualizar produtos e dashboard.',
    permissions: [
      'view_dashboard',
      'manage_orcamentos',
      'view_ecommerce',
      'view_estoque',
      'view_relatorios',
      'manage_tarefas',
      'calibracoes:read',
      'calibracoes:write',
    ],
  },
  cliente: {
    name: 'Cliente Externo',
    description: 'Acesso limitado à visualização do catálogo (e-commerce) para solicitar orçamentos.',
    permissions: [
      'view_ecommerce',
    ],
  },
};
